/**
 * Map a server error envelope to a localised message. The backend ships a
 * stable `code` (+ optional `details` params); ALL display text lives in the
 * `errors` catalog here, so the server stays locale-agnostic. Unmapped codes
 * fall back to the server's own `message` (English) — a safe transitional state
 * as the catalog grows, never a raw key.
 */

/** The shape the API client throws (see api/client.ts `ApiError`). */
export interface ApiErrorLike {
  readonly code?: string;
  readonly message?: string;
  readonly details?: unknown;
}

type TFn = (key: string, opts?: Record<string, unknown>) => string;

/** `t` must be scoped to the `errors` namespace: `useTranslation("errors")`. */
export function apiErrorMessage(err: ApiErrorLike | null | undefined, t: TFn): string {
  if (!err) return "";
  const code = err.code ?? "internal";
  const params =
    err.details && typeof err.details === "object" ? (err.details as Record<string, unknown>) : {};
  return t(code, { ...params, defaultValue: err.message ?? t("internal") });
}
